<template>
  <div>
    <v-dialog v-model="exclude_report" persistent max-width="600px" content-class="elevation-0">
      <v-card
        class="mx-auto align-self-stretch mb-5 mr-5"
        tile
        :loading="edit_form_loading"
        width="auto"
      >
        <v-card elevation="0">
          <v-card-title>
            Excluded Project
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ml-7 header_btn"
                  color="grey"
                  @click="excludeIncludeFromReport(1, 'project')"
                  :disabled="selectedRows.length == 0"
                >
                  <v-icon size="28px">mdi-database-plus</v-icon>
                  <span class="lable_class">Include</span>
                </v-btn>
              </template>
              <span>Include</span>
            </v-tooltip>
          </v-card-title>
          <v-col class="pt-0">
            <v-data-table
              :headers="headers"
              class="elevation-1 rounded-0 my-transaction-table"
              item-key="project_id"
              :items="items.projects"
              dense
              disable-pagination
              hide-default-footer
            >
              <template v-slot:header.select_all>
                <v-simple-checkbox
                  v-model="select_all_checkbox"
                  @input="changeSelectAll()"
                  color="white"
                  :ripple="false"
                  class="select-all-checkbox custom-simple-box white_box"
                  style="color:#ffffff !important;"
                ></v-simple-checkbox>
              </template>
              <template v-slot:item="{ item }">
                <tr>
                  <td width="4%">
                    <v-simple-checkbox
                      v-model="item.selected"
                      :ripple="false"
                      class="custom-simple-box"
                    ></v-simple-checkbox>
                  </td>
                  <td>{{ item.p_name }}</td>
                  <td>{{ (item.customer)?item.customer.full_name:'' }}</td>
                  <td>{{ item.p_code }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-card>
        <v-card elevation="0" v-if="exclude_for=='profit_loss'">
          <v-card-title>
            Excluded chart of account
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ml-7 header_btn"
                  color="grey"
                  @click="excludeIncludeFromReport(1, 'bank')"
                  :disabled="selectedBankRows.length == 0"
                >
                  <v-icon size="28px">mdi-database-plus</v-icon>
                  <span class="lable_class">Include</span>
                </v-btn>
              </template>
              <span>Include</span>
            </v-tooltip>
          </v-card-title>
          <v-col class="pt-0">
            <v-data-table
              :headers="headers1"
              class="elevation-1 rounded-0 my-transaction-table"
              item-key="project_id"
              :items="items.banks"
              dense
              disable-pagination
              hide-default-footer
            >
              <template v-slot:header.select_all>
                <v-simple-checkbox
                  v-model="select_all_bank_checkbox"
                  @input="changeSelectAllBank()"
                  color="white"
                  :ripple="false"
                  class="select-all-checkbox custom-simple-box white_box"
                  style="color:#ffffff !important;"
                ></v-simple-checkbox>
              </template>
              <template v-slot:item="{ item }">
                <tr>
                  <td width="4%">
                    <v-simple-checkbox
                      v-model="item.selected"
                      :ripple="false"
                      class="custom-simple-box"
                    ></v-simple-checkbox>
                  </td>
                  <td>{{ item.bank_name }}</td>
                  <td>{{ item.bank_code }}</td>
                  <td>{{ (item.acctype)?item.acctype.acc_type:'' }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-card>
        <v-card elevation="0" v-if="exclude_for=='profit_loss'">
          <v-card-title>
            Excluded Customer
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ml-7 header_btn"
                  color="grey"
                  @click="excludeIncludeFromReport(1, 'customer')"
                  :disabled="selectedCustomerRows.length == 0"
                >
                  <v-icon size="28px">mdi-database-plus</v-icon>
                  <span class="lable_class">Include</span>
                </v-btn>
              </template>
              <span>Include</span>
            </v-tooltip>
          </v-card-title>
          <v-col class="pt-0">
            <v-data-table
              :headers="headers2"
              class="elevation-1 rounded-0 my-transaction-table"
              item-key="project_id"
              :items="items.customers"
              dense
              disable-pagination
              hide-default-footer
            >
              <template v-slot:header.select_all>
                <v-simple-checkbox
                  v-model="select_all_customer_checkbox"
                  @input="changeSelectAllCustomer()"
                  color="white"
                  :ripple="false"
                  class="select-all-checkbox custom-simple-box white_box"
                  style="color:#ffffff !important;"
                ></v-simple-checkbox>
              </template>
              <template v-slot:item="{ item }">
                <tr>
                  <td width="4%">
                    <v-simple-checkbox
                      v-model="item.selected"
                      :ripple="false"
                      class="custom-simple-box"
                    ></v-simple-checkbox>
                  </td>
                  <td>{{ item.full_name }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-card>

        <v-card elevation="0" v-if="exclude_for=='profit_loss'">
          <v-card-title>
            Excluded Vendor
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ml-7 header_btn"
                  color="grey"
                  @click="excludeIncludeFromReport(1, 'vendor')"
                  :disabled="selectedVendorRows.length == 0"
                >
                  <v-icon size="28px">mdi-database-plus</v-icon>
                  <span class="lable_class">Include</span>
                </v-btn>
              </template>
              <span>Include</span>
            </v-tooltip>
          </v-card-title>
          <v-col class="pt-0">
            <v-data-table
              :headers="headers3"
              class="elevation-1 rounded-0 my-transaction-table"
              item-key="vendor_id"
              :items="items.vendors"
              dense
              disable-pagination
              hide-default-footer
            >
              <template v-slot:header.select_all>
                <v-simple-checkbox
                  v-model="select_all_vendor_checkbox"
                  @input="changeSelectAllVendor()"
                  color="white"
                  :ripple="false"
                  class="select-all-checkbox custom-simple-box white_box"
                  style="color:#ffffff !important;"
                ></v-simple-checkbox>
              </template>
              <template v-slot:item="{ item }">
                <tr>
                  <td width="4%">
                    <v-simple-checkbox
                      v-model="item.selected"
                      :ripple="false"
                      class="custom-simple-box"
                    ></v-simple-checkbox>
                  </td>
                  <td>{{ item.v_name }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-card>

        <v-card-actions class="pa-0">
          <v-btn fab color="error" x-small absolute @click="closePopup()" class="custom-close-btn">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "../../plugins/axios";
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      loading: false,
      edit_form_loading: false,
      select_all_checkbox: false,
      select_all_bank_checkbox: false,
      select_all_customer_checkbox: false,
      select_all_vendor_checkbox: false,
      items: {
        projects: [],
        banks: [],
        customers: [],
        vendors: []
      },
      headers: [
        {
          value: "select_all",
          text: "",
          width: "4%",
          class: "pl-2",
          sortable: false
        },
        { value: "p_name", text: "Project Name", sortable: false },
        { value: "customer.full_name", text: "Customer Name", sortable: false },
        { value: "p_code", text: "Code", sortable: false }
      ],
      headers1: [
        {
          value: "select_all",
          text: "",
          width: "4%",
          class: "pl-2",
          sortable: false
        },
        { value: "bank_name", text: "Bank Name", sortable: false },
        { value: "bank_code", text: "Short Code", sortable: false },
        { value: "acc_type", text: "Type", sortable: false }
      ],
      headers2: [
        {
          value: "select_all",
          text: "",
          width: "4%",
          class: "pl-2",
          sortable: false
        },
        { value: "full_name", text: "Customer Name", sortable: false }
      ],
      headers3: [
        {
          value: "select_all",
          text: "",
          width: "4%",
          class: "pl-2",
          sortable: false
        },
        { value: "v_name", text: "Vendor Name", sortable: false }
      ]
    };
  },
  props: ["exclude_report", "exclude_for"],
  watch: {
    exclude_report: function(value) {
      if (value) {
        this.getExcludedProjectList();
      }
    }
  },
  computed: {
    selectedRows() {
      return this.items.projects.filter(function(item) {
        return item.selected == true;
      });
    },
    selectedBankRows() {
      return this.items.banks.filter(function(item) {
        return item.selected == true;
      });
    },
    selectedCustomerRows() {
      return this.items.customers.filter(function(item) {
        return item.selected == true;
      });
    },
    selectedVendorRows() {
      return this.items.vendors.filter(function(item) {
        return item.selected == true;
      });
    }
  },
  components: {},
  methods: {
    ...mapMutations("utils", ["setAlert"]),
    closePopup() {
      this.$emit("close_popup");
    },
    changeSelectAll() {
      let _self = this;
      if (_self.select_all_checkbox) {
        _self.items.projects = _self.items.projects.map(function(item) {
          item.selected = true;
          return item;
        });
      } else {
        _self.items.projects = _self.items.projects.map(function(item) {
          item.selected = false;
          return item;
        });
      }
    },
    changeSelectAllBank() {
      let _self = this;
      if (_self.select_all_bank_checkbox) {
        _self.items.banks = _self.items.banks.map(function(item) {
          item.selected = true;
          return item;
        });
      } else {
        _self.items.banks = _self.items.banks.map(function(item) {
          item.selected = false;
          return item;
        });
      }
    },
    changeSelectAllCustomer() {
      let _self = this;
      if (_self.select_all_customer_checkbox) {
        _self.items.customers = _self.items.customers.map(function(item) {
          item.selected = true;
          return item;
        });
      } else {
        _self.items.customers = _self.items.customers.map(function(item) {
          item.selected = false;
          return item;
        });
      }
    },
    changeSelectAllVendor() {
      let _self = this;
      if (_self.select_all_vendor_checkbox) {
        _self.items.vendors = _self.items.vendors.map(function(item) {
          item.selected = true;
          return item;
        });
      } else {
        _self.items.vendors = _self.items.vendors.map(function(item) {
          item.selected = false;
          return item;
        });
      }
    },
    getExcludedProjectList() {
      let _self = this;
      this.loading = true;
      axios
        .get("excluded_list?itemsPerPage=-1&exclude_for=" + _self.exclude_for)
        .then(response => {
          _self.items.projects = response.data.data.projects;
          _self.items.banks = response.data.data.banks;
          _self.items.customers = response.data.data.customers;
          _self.items.vendors = response.data.data.vendors;
          // console.log("_self.items.banks", _self.items.banks);
          _self.loading = false;
        })
        .catch(function() {
          _self.loading = false;
        });
    },
    excludeIncludeFromReport(status, data_for) {
      let _self = this;
      let ids = [];

      if (data_for == "project") {
        _self.selectedRows.map(function(item) {
          ids.push(item.project_id);
        });
      }
      if (data_for == "customer") {
        _self.selectedCustomerRows.map(function(item) {
          ids.push(item.customer_id);
        });
      }
      if (data_for == "bank") {
        _self.selectedBankRows.map(function(item) {
          ids.push(item.bank_id);
        });
      }
      if (data_for == "vendor") {
        _self.selectedVendorRows.map(function(item) {
          ids.push(item.vendor_id);
        });
      }
      axios
        .post("exclude_include_from_report", {
          ids: ids,
          status: status,
          exclude_for: "profit_loss",
          data_for: data_for
        })
        .then(function(response) {
          _self.setAlert({
            show: true,
            variant: response.data.variant,
            message: response.data.message,
            dismissCountDown: 0
          });
          _self.getExcludedProjectList();
          _self.$emit("getProjectReportData");
          _self.select_all_checkbox = false;
        })

        .catch(function() {
          console.log("FAILURE!!");
        });
    }
    // excludeIncludeFromProfitLossReport(status) {
    //   let _self = this;
    //   let ids = [];
    //   let customerIds = [];
    //   let vendorIds = [];

    //   axios
    //     .post("exclude_include_from_profit_loss_report", {
    //       ids: ids,
    //       status: status,
    //       exclude_for: "profit_loss",
    //       customerIds: customerIds,
    //       expenseVendorIds: vendorIds
    //     })
    //     .then(function(response) {
    //       _self.setAlert({
    //         show: true,
    //         variant: response.data.variant,
    //         message: response.data.message,
    //         dismissCountDown: 0
    //       });
    //       _self.getExcludedProjectList();
    //       _self.$emit("getProjectReportData");
    //       _self.select_all_checkbox = false;
    //     })

    //     .catch(function() {
    //       console.log("FAILURE!!");
    //     });
    // }
  },
  mounted() {
    // this.getExcludedProjectList();
  }
};
</script>